<h1 mat-dialog-title i18n>Loading data</h1>
<div mat-dialog-content i18n>Please wait!</div>
<div mat-dialog-actions>
  <div class="loading-spinner">
    <mat-spinner diameter="40" strokeWidth="2"></mat-spinner>
  </div>
</div>
